import i18n, { Resource } from "i18next";
import { initReactI18next } from "react-i18next";

import translationAR from "./locales/ar.json";
import translationEN from "./locales/en.json";
import translationTR from "./locales/tr.json";
import { AppLangs } from "./model/shared/enum/AppLangs.enum";

const resources: Record<string, Resource> = {
  en: { translation: translationEN },
  ar: { translation: translationAR },
  tr: { translation: translationTR },
};

// A valid `?lang=` query param wins over the stored language. This is how the
// marketing site hands a visitor's language over (e.g. app.atiraspace.com/
// signup?lang=ar) so the app — login, signup, or any deep link — boots in that
// language with no flash or reload.
const urlLang = Object.values(AppLangs).find(
  (l) =>
    l ===
    new URLSearchParams(window.location.search).get("lang")?.toLowerCase(),
);

const langToUse = (urlLang ||
  window.localStorage.getItem("atiraspace_lang") ||
  AppLangs.EN) as AppLangs;

window.localStorage.setItem("atiraspace_lang", langToUse);

i18n.use(initReactI18next).init({
  resources,
  lng: langToUse,
  fallbackLng: AppLangs.EN,
  interpolation: { escapeValue: false },
});

i18n.on("languageChanged", (lang) => {
  // We need to reload the page to apply the different font
  window.localStorage.setItem("atiraspace_lang", lang);
  window.location.reload();
});

export default i18n;
